// extracted by mini-css-extract-plugin
export default {"full-caller-info":"full-caller-info--ustvT","caller-info":"caller-info--3Oq51","caller-avatar":"caller-avatar--21xcS"};